import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ButtonMiTelcel from "../../atoms/ButtonMiTelcel";
import { getHasDomiciliation } from "../../../store/actions/domiciliation";
import ModalCardLoader from "../ModalCardLoader";
import HasDomiciliationModal from "../HasDomiciliationModal";
import { isObjectEmpty } from "../../organisms/utils";
import { executeTaggeo } from "../../../store/actions";

export default class SchedulePaymentButton extends Component {
  constructor(props) {
    super(props);
    this.schedulePaymentbuttonRef = React.createRef();
    this.state = {
      openHasDomiciliationModal: false,
      CpMessage: "CP0005",
      isNewValidateDomiciliationRequest: false,
    };
  }

  handleOnClick = () => {
    const {
      lineNumber,
      serviceId,
      getHasDomiciliation,
      executeTaggeo,
      tagServiceId,
    } = this.props;
    this.setState({ isNewValidateDomiciliationRequest: true });
    getHasDomiciliation(lineNumber, serviceId);
    executeTaggeo({
      action: "Click Domiciliar",
      step: "Pantalla principal",
      service: tagServiceId,
      eventName: "telcel",
    });
  };
  render() {
    const {
      amount,
      hasN2,
      hasDmResponse,
      isLoadingServiceDomiciliation,
      hasDmError,
      history,
      tagServiceId,
      lineNumber,
      goToDomiciliationForm,
    } = this.props;

    const { isNewValidateDomiciliationRequest } = this.state;
    const bottonIsValid = (hasN2 && amount > 0) || goToDomiciliationForm;
    setTimeout(() => {
      if (
        !isObjectEmpty(hasDmResponse) &&
        !hasDmResponse.data.domiciliation &&
        goToDomiciliationForm &&
        this.schedulePaymentbuttonRef.current
      ) {
        this.schedulePaymentbuttonRef.current.click();
      }
    }, 500);

    return (
      <>
        <ButtonMiTelcel
          height={"3.5em"}
          backgroundColor="#fff"
          margin={"0px auto"}
          width={"-webkit-fill-available"}
          style={{
            display: "flex",
            justifyContent: "center",
            background: bottonIsValid ? "#fff" : "#ccc",
            color: bottonIsValid ? "#000" : "#999",
            border: bottonIsValid ? "1px solid black" : "1px solid #ccc",
          }}
          disabled={!bottonIsValid}
          onClick={() => {
            this.handleOnClick();
          }}
          innerRef={this.schedulePaymentbuttonRef}
        >
          Domiciliar
        </ButtonMiTelcel>
        <ModalCardLoader isOpen={isLoadingServiceDomiciliation} />
        {(isNewValidateDomiciliationRequest &&
          !isLoadingServiceDomiciliation &&
          !isObjectEmpty(hasDmResponse)) ||
        (!isLoadingServiceDomiciliation && hasDmError) ? (
          <HasDomiciliationModal
            hasDmResponse={hasDmResponse}
            hasDmError={hasDmError}
            history={history}
            accountValue={lineNumber}
            amount={String(amount)}
            tagServiceId={tagServiceId}
          />
        ) : (
          <></>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const {
    domiciliationReducer: {
      hasDomiciliationServiceResponseError,
      hasDomiciliationServiceResponseSuccess,
      isLoadingServiceDomiciliation,
      goToDomiciliationForm,
    },
  } = state;

  return {
    hasDmError: hasDomiciliationServiceResponseError,
    isLoadingServiceDomiciliation,
    hasDmResponse: hasDomiciliationServiceResponseSuccess,
    goToDomiciliationForm,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getHasDomiciliation,
      executeTaggeo,
    },
    dispatch
  );
}

SchedulePaymentButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(SchedulePaymentButton);
